module.exports = __webpack_public_path__ + "img/01.85824c8a.jpg";